import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { pNFT_RARITY, pNFT_RARITIES, genesis_RARITY } from '../constants';

import { ReactComponent as QuestionMark } from '../assets/question-mark-circle.svg';
import { StakingContext } from '../../../contexts/StakingContext';

const rarityDisplayName = {
    [pNFT_RARITY.legendary]: "Legendary",
    [pNFT_RARITY.epic]: "Epic",
    [pNFT_RARITY.rare]: "Rare",
    [pNFT_RARITY.uncommon]: "Uncommon",
}

// TODO: get the mint price in EDU
// const MINT_PRICE_USD = 433;
const MINT_PRICE_EDU = 636;

// likely data structure
const publisherGLobalStaked = {
    [pNFT_RARITY.legendary]: 13,
    [pNFT_RARITY.epic]: 34,
    [pNFT_RARITY.rare]: 12,
    [pNFT_RARITY.uncommon]: 73,
}

const genesisGlobalStaked = {
    [genesis_RARITY.golden]: 34,
    [genesis_RARITY.silver]: 69
}

const genesisGlobalStakedByPublisherRarity = {
    [pNFT_RARITY.legendary]: 34,
    [pNFT_RARITY.epic]: 12,
    [pNFT_RARITY.rare]: 65,
    [pNFT_RARITY.uncommon]: 29,
}

const BASE_APY = {
    [pNFT_RARITY.legendary]: '1.1x - 1.3x',
    [pNFT_RARITY.epic]: '1.4x - 2.3x',
    [pNFT_RARITY.rare]: '2.3x - 4.2x',
    [pNFT_RARITY.uncommon]: '4.2x - 12.3x',
}

const MAX_APY = {
    [pNFT_RARITY.legendary]: '4.1x - 6.4x',
    [pNFT_RARITY.epic]: '6.7x - 11.7x',
    [pNFT_RARITY.rare]: '9.1x - 16.7x',
    [pNFT_RARITY.uncommon]: '16.8x - 49.1x',
}

const eduPriceUSD = 0.65 // from oracle
const calcMaxAPY = (ratePerBlock) => {
    const secondsInYear = 31536000;
    const avgBSCBlockTime = 3;
    // return secondsInYear / avgBSCBlockTime * ratePerBlock * eduPriceUSD / MINT_PRICE_USD;
    return secondsInYear / avgBSCBlockTime * ratePerBlock / MINT_PRICE_EDU;
}

const calcMaxMonthlyYield = (ratePerBlock) => {
    const secondsInMonth = 2628000;
    const avgBSCBlockTime = 3;

    return secondsInMonth / avgBSCBlockTime * ratePerBlock;
}


export function GlobalStakes() {
    const [maxYieldPerRarity, setMaxYieldPerRarity] = useState();
    const { metadata } = useContext(StakingContext);

    // calculating max apy per rarity
    useEffect(() => {
        const calculateMaxAPY = async (metadata) => {
            // legendary
            const sortedYields = Object.values(metadata).sort((a, b) => a.yieldPerBlock <= b.yieldPerBlock);

            setMaxYieldPerRarity({
                [pNFT_RARITY.legendary]: sortedYields.find(x => x.tier.toLowerCase() === pNFT_RARITY.legendary).yieldPerBlock,
                [pNFT_RARITY.epic]: sortedYields.find(x => x.tier.toLowerCase() === pNFT_RARITY.epic).yieldPerBlock,
                [pNFT_RARITY.rare]: sortedYields.find(x => x.tier.toLowerCase() === pNFT_RARITY.rare).yieldPerBlock,
                [pNFT_RARITY.uncommon]: sortedYields.find(x => x.tier.toLowerCase() === pNFT_RARITY.uncommon).yieldPerBlock
            })
            // metadata.filter(x => x.tier.toLowerCase() === pNFT_RARITY.legendary).sort()
        }

        if(Object.keys(metadata).length) {
            calculateMaxAPY(metadata);
        }
    }, [metadata])

    // useEffect(() => {
    //     console.log(maxApy)
    // }, [maxApy])

    // const baseAPYTooltip = (props) => (<Tooltip>Based on average historic revenue. However it does not guarantee future revenue return.</Tooltip>)
    const baseAPYTooltip = <Tooltip>Based on average historic revenue. However it does not guarantee future revenue return.</Tooltip>
    const maxAPYTooltip = <Tooltip>Based on initial mint price and latest $EDU token price.</Tooltip>
    
    return <Container>
        <Row className='header-row'>
            <Col xs={12} sm={4}>Tier</Col>
            <Col xs={12} sm={4}>Base Multiplier <OverlayTrigger placement='bottom' delay={{show: 50, hide: 250}} overlay={baseAPYTooltip}><QuestionMark /></OverlayTrigger></Col>
            <Col xs={12} sm={4}>Current Multiplier</Col>
            {/* <Col xs={12} sm={4}>Current Boosted Multiplier <OverlayTrigger placement='bottom' delay={{show: 50, hide: 250}} overlay={maxAPYTooltip}><QuestionMark /></OverlayTrigger></Col> */}
            {/* <Col>pNFT Staked</Col>
            <Col>Genesis NFT Staked</Col> */}
        </Row>
        {pNFT_RARITIES.map(rarity => (<DataPanel key={rarity} rarity={rarity} maxYieldPerRarity={maxYieldPerRarity}  />))}
        
    </Container>
}

function DataPanel({rarity, maxYieldPerRarity}) {
    const [maxApy, setMaxApy] = useState();
    const [maxYield, setMaxYield] = useState();

    useEffect(() => {
        if(rarity && maxYieldPerRarity) {
            setMaxApy(calcMaxAPY(maxYieldPerRarity[rarity]))
            setMaxYield(calcMaxMonthlyYield(maxYieldPerRarity[rarity]))
        }
    }, [rarity, maxYieldPerRarity])

    const percentageFormat = new Intl.NumberFormat(undefined, {style: "percent", maximumSignificantDigits: 3});
    const numberFormat = new Intl.NumberFormat()

    return <Row>
        <Col className='rarity' xs={12} sm={4}>{rarityDisplayName[rarity]}</Col>
        <Col className='base-apy' xs={12} sm={4}>{BASE_APY[rarity]}</Col>
        <Col className='max-apy' xs={12} sm={4}>
            {/* <span className='emph'>{isNaN(maxApy) ? '' : percentageFormat.format(maxApy) }</span> <br /> */}
            <span className='emph'>{BASE_APY[rarity]}</span> <br />
            {/* {isNaN(maxYield) ? '' : numberFormat.format(maxYield)} EDU per month */}
        </Col>
        {/* <Col>{publisherGLobalStaked[rarity]}</Col>
        <Col>{genesisGlobalStakedByPublisherRarity[rarity]}</Col> */}
    </Row>
}